import { Box, Stack, Typography } from '@mui/material';
import NProgress from 'nprogress';
import { useEffect } from 'react';

interface Props {
  message?: string;
}

function SuspenseLoader({ message }: Props) {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
      }}
      display='flex'
      alignItems='center'
      justifyContent='center'
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        <img src={'/static/images/brand/loader.svg'} alt='Logo' width={'100px'} />
        <Typography variant='h6'>{message}</Typography>
      </Stack>
    </Box >
  );
}

export default SuspenseLoader;
